import React, { useRef } from "react";
import styled from "styled-components";

// may be used later
// const DropModalWrapper = styled.div`
//   background: rgba(202, 146, 221, 0.7);
//   backdrop-filter: blur(2px);
//   position: fixed;
//   width: 100%;
//   height: 100vh;
//   top: 0;
//   left: 0;
//   right: 0;
//   z-index: 2000;
// `;
const DropdownModalContainer = styled.div`
  position: absolute;
  top: 39px;
  background: rgb(255, 255, 255);
  padding: 5px;
  z-index: 10000;
  border: 1px solid rgb(229, 231, 235);
`;

interface DropdownModalProps {
  isOpen: boolean;
  children: React.ReactNode;
}
const DropdownModal: React.FC<DropdownModalProps> = ({ isOpen, children }) => {
  const dropdownRef = useRef(null);

  // <DropModalWrapper ref={dropdownRef}>
  return (
    <>
      {isOpen && (
        <DropdownModalContainer ref={dropdownRef}>
          <div className="p-4">
            <div className="mb-4 flex items-center justify-between"></div>
            <div>{children}</div>
          </div>
        </DropdownModalContainer>
      )}
    </>

    // </DropModalWrapper>
  );
};

export default DropdownModal;
